import List from "@/components/list";

const Table = args => {
  const AccountTableConfig = [
    {
      label: "所在行",
      prop: "row",
      minWidth: "80",
      showOverflowTooltip: true
    },
    {
      label: "唯一标识",
      prop: "unique",
      minWidth: "120",
      showOverflowTooltip: true
    },
    {
      label: "错误原因",
      prop: "reason",
      minWidth: "180",
      showOverflowTooltip: true
    }
  ];
  return <List {...args} talbeCols={AccountTableConfig} />;
};

export default Table;
